module.exports = __webpack_public_path__ + "img/pic2.ce4a707a.jpg";